define(["exports", "@babel/runtime/helpers/esm/inheritsLoose", "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose", "react", "styled-components", "../../themes"], function (_exports, _inheritsLoose2, _taggedTemplateLiteralLoose2, _react, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _inheritsLoose2 = _interopRequireDefault(_inheritsLoose2);
  _taggedTemplateLiteralLoose2 = _interopRequireDefault(_taggedTemplateLiteralLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var _templateObject;

  var Body = _styledComponents.default.div.withConfig({
    displayName: "ModalBody__Body",
    componentId: "sc-iakeh-0"
  })(["max-height:calc(100vh - 146px);overflow-x:auto;padding:5px;margin:-5px;", " h1{margin:0;}"], _themes.device.desktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n    max-height: calc(60vh);\n    position: relative;  \n  "]))));

  var ModalBody = /*#__PURE__*/function (_Component) {
    (0, _inheritsLoose2.default)(ModalBody, _Component);

    function ModalBody() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = ModalBody.prototype;

    _proto.render = function render() {
      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement(Body, null, children);
    };

    return ModalBody;
  }(_react.Component);

  var _default = ModalBody;
  _exports.default = _default;
});